// TODO move to packages
import queryString from 'query-string'

export default function stringifyQueryObjectUtil (queryParams) {
  return queryString.stringify(queryParams)
}
